<template>
  <v-dialog v-model="isShow" persistent width="500">
    <v-card outlined elevation="0">
      <v-card-title>
        <span>Detail Member</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="mt-0">
          <v-col cols="12">
            <span>Nama: </span>
            <span>{{ member.fullname }}</span>
          </v-col>
          <v-col cols="12">
            <span>Email: </span>
            <span>{{ member.email }}</span>
          </v-col>
          <v-col cols="12">
            <span>Tempat lahir: </span>
            <span>{{ member.place_of_birth }}</span>
          </v-col>
          <v-col cols="12">
            <span>Tanggal lahir: </span>
            {{ FormatDate(member.date_of_birth) }}
          </v-col>
          <v-col cols="12">
            <span>No Telpon: </span>
            <span>{{ member.phone_number }}</span>
          </v-col>
          <v-col cols="12">
            <span>Alamat: </span>
            <span>{{ member.meta?.residential_address }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn elevation="0" @click="isShow = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    model: Boolean,
    member: {
      type: Object,
      default: () => ({}),
    },
  },
  model: {
    prop: "model",
    event: "update:model",
  },
  computed: {
    isShow: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit("update:model", value);
      },
    },
  },
  methods: {
    FormatDate(dateOld) {
      if (!dateOld) return "";

      const date = new Date(dateOld);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
};
</script>
